'use es6';

import { connect } from 'react-redux';
import { removeAttachmentFromThread } from '../../file-uploads/actions/removeAttachmentFromThread';
import { selectAttachmentFile } from '../../file-uploads/actions/selectAttachmentFile';
import { getFileUploadListForCurrentThreadId } from '../../file-uploads/selectors/getFileUploadListForCurrentThreadId';
import { publishVisitorMessage } from '../../pubsub/actions/publishVisitorMessage';
import { canPublish } from '../../pubsub/selectors/canPublish';
import { pubsubConnectionFailed } from '../../pubsub/selectors/pubsubConnectionFailed';
import { getSelectedThread } from '../../selected-thread/selectors/getSelectedThread';
import { getColoring } from '../../selectors/widgetDataSelectors/getColoring';
import { getMessagesPageUri } from '../../selectors/widgetDataSelectors/getMessagesPageUri';
import { getShowingHsBranding } from '../../selectors/widgetDataSelectors/getShowingHsBranding';
import { hasUnansweredQuickReplyMessage } from '../../selectors/chatSelectors';
import { publishTypingMessage } from '../../typing-indicators/actions/publishTypingMessage';
import MessageEditorWrapper from '../components/MessageEditorWrapper';
import { closeInitialMessageBubble } from '../../initial-message-bubble/actions/closeInitialMessageBubble';
import { getShowInitialMessageBubble } from '../../initial-message-bubble/selectors/getShowInitialMessageBubble';
import { getAllowUserInput } from '../../thread-histories/selectors/getAllowUserInput';
import { getIsAIChatbot } from '../../selectors/widgetDataSelectors/getIsAIChatbot';
import { getIsBot } from '../../selectors/widgetDataSelectors/getIsBot';
import { getIsMobile } from '../../selectors/getIsMobile';
import { getIsIOSMobile } from '../../selectors/getIsIOSMobile';
import { toggleOnAndOffInputFocus } from '../../actions/inputEventActions';
import { getInputFocus } from '../../visitor-widget/selectors/getInputFocus';
import { getShouldDisableAttachments } from '../../widget-ui/selectors/getShouldDisableAttachments';
import { getShouldDisableInitialInputFocus } from '../../widget-ui/selectors/getShouldDisableInitialInputFocus';
import { getMessageEditorText } from '../../message-editor/selectors/getMessageEditorText';
import { setMessageEditorStagingText, removeMessageEditorStagingText } from '../../actions/messageEditorActions';
import { getIsPortal53 } from '../../widget-data/operators/getIsPortal53';
import { isPersistedThread } from '../../threads/operators/isPersistedThread';
import { getAssignedAgentId } from '../../threads/operators/threadGetters';
import { getIsWidgetInAwayMode } from '../../availability/selectors/getIsWidgetInAwayMode';
import { canUploadAttachments } from '../../attachments/selectors/canUploadAttachments';
import { getTypingMessageShouldDisableUserInput } from '../../typing-indicators/selectors/getTypingMessageShouldDisableUserInput';
import { getChatflowName, getIsUngatedForSpeechPoc, getIsUngatedForScreenCapture, getIsUngatedForCustomerAgentPrompts } from '../../widget-data/selectors/widgetDataSelectors';
import { getChatHeadingResponders } from '../../responders/selectors/getChatHeadingResponders';
import { getLatestWidgetData } from '../../widget-data/selectors/getLatestWidgetData';
import { getSpamProtectionMetadata } from 'conversations-internal-schema/widget-data/operators/widgetDataGetters';
import { attachmentsErrorForThreadInProps } from '../../file-uploads/selectors/attachmentsErrorForThreadInProps';
const mapStateToProps = state => {
  var _state$speechPoc, _state$speechPoc2;
  const currentConversation = getSelectedThread(state);
  const currentMessageDoesNotAllowInput = !getAllowUserInput(state, {
    thread: currentConversation
  }) && hasUnansweredQuickReplyMessage(state, {
    thread: currentConversation
  });
  const isAwayAndIsBotAndHasntStartedConversation = getIsBot(state) && getIsWidgetInAwayMode(state) && !isPersistedThread(currentConversation);
  const shouldDisableUserInput = getTypingMessageShouldDisableUserInput(state);
  const chatHeadingResponders = getChatHeadingResponders(state);
  const isResponderAI = chatHeadingResponders.some(responder => responder.get('isResponderAI')) || getIsAIChatbot(state) && getAssignedAgentId(currentConversation) === null;
  const chatflowName = getChatflowName(state);
  const isSalesbot = getIsPortal53() && /Salesbot/i.test(chatflowName);
  const enableAIDisclaimer = isSalesbot || isResponderAI;
  const widgetData = getLatestWidgetData(state);
  const spamProtectionMetadata = getSpamProtectionMetadata(widgetData);
  const spamProtectionEnabled = Boolean(spamProtectionMetadata === null || spamProtectionMetadata === void 0 ? void 0 : spamProtectionMetadata.token);
  return {
    coloring: getColoring(state),
    currentConversation,
    disablePublish: !canPublish(state),
    disableTextInput: shouldDisableUserInput || currentMessageDoesNotAllowInput || isAwayAndIsBotAndHasntStartedConversation,
    showQuickReplyPlaceholder: currentMessageDoesNotAllowInput,
    enableAIDisclaimer,
    isOnFocus: getInputFocus(state),
    stagedMessage: getMessageEditorText(state),
    messagesPageUri: getMessagesPageUri(state),
    networkOffline: pubsubConnectionFailed(state),
    showingHsBranding: getShowingHsBranding(state),
    showInitialMessageBubble: getShowInitialMessageBubble(state),
    spamProtectionEnabled,
    stagedAttachments: getFileUploadListForCurrentThreadId(state),
    attachmentsError: attachmentsErrorForThreadInProps(state, {
      thread: currentConversation
    }),
    mobile: getIsMobile(state),
    isIOSMobile: getIsIOSMobile(state),
    shouldHideAttachmentButton: getShouldDisableAttachments(state),
    shouldDisableInitialInputFocus: getShouldDisableInitialInputFocus(state),
    shouldSendInputStagingEvent: getIsPortal53(),
    canUploadAttachments: canUploadAttachments(state, {
      thread: currentConversation
    }),
    speechPocActive: getIsUngatedForSpeechPoc(state) && ((_state$speechPoc = state.speechPoc) === null || _state$speechPoc === void 0 ? void 0 : _state$speechPoc.speechPocActive),
    speechRecordingStatus: (_state$speechPoc2 = state.speechPoc) === null || _state$speechPoc2 === void 0 ? void 0 : _state$speechPoc2.speechRecordingStatus,
    isUngatedForScreenCapture: getIsUngatedForScreenCapture(state),
    isUngatedForCustomerAgentPrompts: getIsUngatedForCustomerAgentPrompts(state)
  };
};
const mapDispatchToProps = {
  closeInitialMessageBubble,
  onRemoveAttachment: removeAttachmentFromThread,
  onSelectAttachmentFile: selectAttachmentFile,
  publishMessage: publishVisitorMessage,
  publishTypingMessage,
  toggleOnAndOffInputFocus,
  setMessageEditorStagingText,
  removeMessageEditorStagingText
};
export default connect(mapStateToProps, mapDispatchToProps)(MessageEditorWrapper);